import React, { useEffect, useState } from 'react'
import AdminDashboard from './AdminDashboard'
import '../../assets/css/admin/Admin-Dashboard.css'
import axios from 'axios'
import 'intl-tel-input/build/css/intlTelInput.css'; // Assuming CSS import is necessary
import Swal from 'sweetalert2'

const DeleteInstitute = () => {

    const [institute, setInstitute] = useState([])

    const getAllData = () => {
        axios.get('https://api.myskills.lk/ins/deleted').then((response) => {
            console.log(response.data)
            setInstitute(response.data)
        }).catch((error) => {
            console.log(error)
        })
    }

    useEffect(() => {
        getAllData();
    }, [])


    const UpdateDelete = (e, id) => {

        e.preventDefault();
        console.log(id);

        const ddata = {
            deleted: "false"
        }

        Swal.fire({
            title: "Are you sure?",
            text: "Do you want to Restore this?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, Restore it!"
        }).then((result) => {
            if (result.isConfirmed) {
                axios.put('https://api.myskills.lk/ins/delete/' + id, ddata).then((response) => {
                    console.log(response.data);
                    getAllData()
                }).catch((err) => {
                    console.log(err);
                })
                Swal.fire({
                    title: "Restored!",
                    text: "Your file has been Restored.",
                    icon: "success"
                });
            }
        });


    }


    const deleteNow = (e, id) => {

        e.preventDefault();

        axios.post('https://api.myskills.lk/ins/deletenow/' + id).then(() => {
            Swal.fire({
                title: "Deleted!",
                text: "Your file has been Deleted.",
                icon: "success"
            });
            getAllData();
        }).catch((err) => {
            alert("Error")
        })

       
    }

    const [searchTerm, setSearchTerm] = useState('')

    const handleSearch = (e) => {
        setSearchTerm(e.target.value)
    }

    const filteredInstitutes = institute.filter((institute) =>
        institute.in_name.toLowerCase().includes(searchTerm.toLowerCase())
    );


    return (
        <div>

            <AdminDashboard />

            <div className='AllViews-admin'>

                <div className="search-icon-admin admin-institute-search">

                    <h1>DELETE INSTITUTE</h1>
                    <form >
                        <input type="text" onChange={handleSearch} id="" placeholder='Search Item' />
                        <input type="submit" value="SEARCH" />
                    </form>

                </div>

                <div className="scroller-box">
                    <div className="table-institute">
                        <table>
                            <thead>
                                <tr> 
                                    <th>Institute Name</th>
                                    <th>Institute Type</th>
                                    <th>Request Date</th>
                                    <th>Person name</th>
                                    <th>Person No</th>
                                    <th>View</th>
                                    <th>Action</th>

                                </tr>
                            </thead>

                            <tbody>


                                {filteredInstitutes.length > 0 ? (
                                    filteredInstitutes.map((institute) => (
                                        <tr key={institute.id}>
                                            <td>{institute.in_name}</td>
                                            <td>{institute.type}</td>
                                            <td>{institute.date}</td>
                                            <td>{institute.pname}</td>
                                            <td>{institute.pconatct}</td>
                                            <td>
                                                <button id="view-web">
                                                    <a href={`/institutesview/${institute.id}`}>SITE VIEW</a>
                                                </button>
                                            </td>
                                            <td id="action-buttons">
                                                <button
                                                    id="blue-admin"
                                                    onClick={(e) => {
                                                        UpdateDelete(e, institute.id);
                                                    }}
                                                >
                                                    RESTORE
                                                </button>
                                                <button
                                                    onClick={(e) => {
                                                        deleteNow(e, institute.id);
                                                    }}
                                                    id="del-details"
                                                >
                                                    DELETE
                                                </button>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="7" style={{ textAlign: 'center', padding: '10px' }}>
                                            Search data not found
                                        </td>
                                    </tr>
                                )}





                            </tbody>
                        </table>

                    </div>

                </div>

            </div>



        </div>

    )
}

export default DeleteInstitute